
export default (function (x) { return x.default || x })(require('./autocompleteImpl.js'))
